<div class="tpr-page-container">
  <app-valuation-info-header
    [showGlobalSettingsButton]="selectedTabIndex === 1"
  ></app-valuation-info-header>
  <nz-tabset
    [(nzSelectedIndex)]="selectedTabIndex"
    (nzSelectChange)="onTabChange($event)"
  >
    <nz-tab [nzTitle]="companyTabTitle">
      <app-tpr-company
        [primaryTicker]="primaryTicker"
        [isTabVisible]="selectedTabIndex === 0"
      ></app-tpr-company>
    </nz-tab>
    <nz-tab [nzTitle]="vsPeerTabTitle" [nzDisabled]="!showTprVsPeersTab">
      <app-tpr-peers
        [primaryTicker]="primaryTicker"
        [isPeerTabVisible]="isPeerTabVisible"
      ></app-tpr-peers>
    </nz-tab>
  </nz-tabset>
</div>
